import { BaseModel } from './BaseModel';
import ConsentType from './ConsentType';
import Post from './Post';
import Section from './Section';
import User from './User';

export class Consent extends BaseModel {
  static get entity() {
    return 'consents';
  }

  static get fk() {
    return 'consent_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      consent: this.boolean(false),
      consent_type: this.hasOne(ConsentType, 'consent_id'),
      uid: this.string(''),
      user_id: this.attr(null),
      user: this.belongsTo(User, 'user_id'),
      post_id: this.attr(null),
      post: this.belongsTo(Post, 'post_id'),
      section_id: this.attr(null),
      section: this.belongsTo(Section, 'section_id'),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      fetch(params) {
        return this.get(`/consents`, { params });
      },

      fetchById(id) {
        return this.get(`/consents/${id}`);
      },

      create(body) {
        return this.post(`/consents`, body);
      },

      update(id, body) {
        return this.put(`/consents/${id}`, body);
      }
    }
  };
}

export default Consent;
